module.exports = __webpack_public_path__ + "static/tüv_süd-757f2dd4a437dc19eb3952556a7b06de.png";